/** Matches the CSS media feature of the same name. */
export const COARSE_POINTER_QUERY = '(pointer: coarse)';

interface MatchMediaWindow {
  matchMedia?: (query: string) => { matches: boolean };
}

/**
 * True when the primary pointer is a finger rather than a mouse.
 *
 * This is deliberately not a width breakpoint. What breaks on touch is the
 * absence of a caret, hover and a precise tap target — a tablet in landscape is
 * wider than `$mobile-max` and has every one of those problems.
 */
export function isCoarsePointer(win: MatchMediaWindow): boolean {
  if (typeof win.matchMedia !== 'function') return false;
  return win.matchMedia(COARSE_POINTER_QUERY).matches;
}
